<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24" :offset="0" style="text-align: end;">
        <el-button size="mini" type="primary" @click="resrtAll">Reset All</el-button>
      </el-col>
    </el-row>
    
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-input @keyup.enter.native="create()" class="input-text" :placeholder="$t('project_tab_info_toDo_input')" v-model="input"></el-input>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        
        <draggable
          :list="list"
          class="list-group"
          :move="checkMove"
          @end="onEnd">
          <div
            class="list-group-item"
            v-for="element in list"
            :key="element.name"
            :title="element.user.fullName">

            <el-row :gutter="20">
              <el-col :span="1">
                <img src="@/assets/img/info/dnd.png" alt="">
              </el-col>
              <el-col :span="1">
                <i @click="changeStatus(element.id, element.status)" v-if="!element.status" class="el-icon-circle-plus-outline"></i>
                <i @click="changeStatus(element.id, element.status)" v-else class="el-icon-circle-check"></i>
              </el-col>
              <el-col :span="20">
                <span :class="{'line-through': element.status}">{{ element.description }}</span>
              </el-col>
              <el-col :span="1">
                <i @click="editItem(element.id, element.description)" class="el-icon-edit"></i>
              </el-col>
              <el-col :span="1">
                <i @click="deleteItem(element.id)" class="el-icon-delete"></i>
              </el-col>
            </el-row>
            
          </div>
        </draggable>

      </el-col>
    </el-row>

  </div>
</template>

<script>
  import axios from 'axios'
  import draggable from 'vuedraggable'

  export default {
    components: {
      draggable,
    },
    data() {
      return {
        input: '',
        itemID: null,
      }
    },
    computed: {
      list() {
        return this.$store.state.toDo.toDo
      }
    },
    methods: {
      resrtAll() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/todo/reset?companyId=${this.$route.query.companyId}&taskId=${this.$route.query.taskId}&type=project`)
          .then(response => {
            this.$store.dispatch('toDo', 'project')
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      checkMove(e) {
        // eslint-disable-next-line no-console
        console.log('e', e)

        this.itemID = e.draggedContext.element.id
      },
      onEnd(e) {
        // eslint-disable-next-line no-console
        console.log('e', e)

        if (e.newIndex != e.oldIndex) {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/todo/move?todoId=${this.itemID}`, {
            companyId: Number(this.$route.query.companyId),
            taskId: Number(this.$route.query.taskId),
            type: 'project',
            newIndex: e.newIndex + 1
          })
            .then(response => {
              this.$store.dispatch('toDo', 'project')
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }
      },
      create() {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/todo/create`, {
          companyId: Number(this.$route.query.companyId),
          taskId: Number(this.$route.query.taskId),
          type: 'project',
          description: this.input
        })
          .then(response => {
            this.$store.dispatch('toDo', 'project')
            this.input = ''
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      changeStatus(id, status) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/todo/change-status?todoId=${id}`, {
          done: !status
        })
          .then(response => {
            this.$store.dispatch('toDo', 'project')
            this.input = ''
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      },
      editItem(id, description) {
        this.$prompt('', this.$i18n.t('project_tab_info_toDo_item'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          inputValue: description,
          // inputPattern: /\D/,
          // inputErrorMessage: 'Please input item'
        }).then(({ value }) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios.post(`/api/v1/todo/update?todoId=${id}`, {
            description: value
          })
            .then(response => {
              this.$store.dispatch('toDo', 'project')
              loader.hide()
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
              
        });
      },
      deleteItem(id) {
        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios.post(`/api/v1/todo/delete?todoId=${id}`)
          .then(response => {
            this.$store.dispatch('toDo', 'project')
            loader.hide()
          })
          .catch(error => {
            console.log('An error occurred:', error);
            loader.hide()
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
.input-text {
  font-size: 16px;
}

.list {
  &-group {
    &-item {
      font-size: 18px;
      padding: 14px;
      margin-bottom: -1px;
      border-bottom: 1px solid rgba(0,0,0,.125);
      cursor: pointer;
    }
  }
}

.el-icon-edit {
  font-size: 20px;
  &:hover {
    color: #409eff;
  }
}

.el-icon-delete {
  font-size: 20px;
  &:hover {
    color: #f56c6c;
  }
}

.el-icon-circle-plus-outline {
  font-size: 22px;
}

.el-icon-circle-check {
  font-size: 22px;
  color: #67c23a;
}

.line-through {
  text-decoration: line-through;
}
</style>